import { Ds } from "@accurx/design";
import styled from "styled-components";

export const StyledHyphenatedText = styled(Ds.Text)`
    white-space: pre-line;
    word-break: break-word;
    hyphens: auto;
`;

const StyledSubHeadingContainer = styled(Ds.Flex).attrs({
    justifyContent: "space-between",
    alignItems: "center",
})`
    padding: 0.5rem 1rem;

    border-bottom: 1px solid var(--ds-color-silver);
    border-top: 1px solid var(--ds-color-silver);
`;

const StyledList = styled.ul`
    list-style: none;
    padding: 0;
    margin: 0;
`;

const StyledHeading = styled.div`
    z-index: 1;
    position: sticky;
    top: 0;
    background: var(--ds-color-cloud);
    padding: 0.5rem 1rem;
`;

export const StyledTemplateListSection = {
    Heading: StyledHeading,
    List: StyledList,
    SubHeading: StyledSubHeadingContainer,
};
